import React from 'react';
import { Users, UserCheck, UserX } from 'lucide-react';
import { AdminStatCard } from './AdminStatCard';
import type { OrganizationStatistics } from '@/lib/api/statistics';

interface AdminStaffTabProps {
  statistics: OrganizationStatistics | null;
  isLoading: boolean;
}

export const AdminStaffTab: React.FC<AdminStaffTabProps> = ({ statistics, isLoading }) => {
  return (
    <div className="space-y-4">
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
        <AdminStatCard
          icon={<Users className="h-6 w-6" />}
          title="Total Practitioners"
          value={statistics?.staff.totalPractitioners || 0}
          isLoading={isLoading}
        />
        <AdminStatCard
          icon={<UserCheck className="h-6 w-6 text-green-600" />}
          title="Active"
          value={statistics?.staff.activePractitioners || 0}
          isLoading={isLoading}
        />
        <AdminStatCard
          icon={<UserX className="h-6 w-6 text-red-600" />}
          title="Inactive"
          value={statistics?.staff.inactivePractitioners || 0}
          isLoading={isLoading}
        />
      </div>
      {statistics?.staff.practitioners && statistics.staff.practitioners.length > 0 && (
        <div className="rounded-lg border border-gray-200 bg-white">
          <div className="border-b border-gray-200 px-4 py-3">
            <h3 className="font-hanken text-sm font-semibold text-gray-700">Practitioners</h3>
          </div>
          <div className="overflow-x-auto">
            <table className="w-full min-w-[600px] border-collapse">
              <thead className="bg-gray-50">
                <tr>
                  <th className="whitespace-nowrap px-4 py-2.5 text-left align-middle font-hanken text-xs font-medium text-gray-600">
                    Name
                  </th>
                  <th className="whitespace-nowrap px-4 py-2.5 text-left align-middle font-hanken text-xs font-medium text-gray-600">
                    Role
                  </th>
                  <th className="whitespace-nowrap px-4 py-2.5 text-left align-middle font-hanken text-xs font-medium text-gray-600">
                    Specialty
                  </th>
                  <th className="whitespace-nowrap px-4 py-2.5 text-left align-middle font-hanken text-xs font-medium text-gray-600">
                    Status
                  </th>
                  <th className="whitespace-nowrap px-4 py-2.5 text-left align-middle font-hanken text-xs font-medium text-gray-600">
                    Phone
                  </th>
                  <th className="whitespace-nowrap px-4 py-2.5 text-left align-middle font-hanken text-xs font-medium text-gray-600">
                    Email
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200">
                {statistics.staff.practitioners.map((p) => (
                  <tr key={p.id} className="hover:bg-gray-50">
                    <td className="px-4 py-2.5 align-middle font-hanken text-sm text-gray-900">
                      {p.name}
                    </td>
                    <td className="px-4 py-2.5 align-middle font-hanken text-sm text-gray-600">
                      {p.role || '-'}
                    </td>
                    <td className="px-4 py-2.5 align-middle font-hanken text-sm text-gray-600">
                      {p.specialty || '-'}
                    </td>
                    <td className="px-4 py-2.5 align-middle">
                      <span
                        className={`inline-flex rounded-full px-2 py-1 text-xs font-medium ${p.status === 'active' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`}
                      >
                        {p.status}
                      </span>
                    </td>
                    <td className="px-4 py-2.5 align-middle font-hanken text-sm text-gray-600">
                      {p.phone || '-'}
                    </td>
                    <td className="px-4 py-2.5 align-middle font-hanken text-sm text-gray-600">
                      {p.email || '-'}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
};
